// extracted by mini-css-extract-plugin
export default {"shadowed":"Home_shadowed__TEU04","hand":"Home_hand__zQMWH","wave":"Home_wave__OrfYm"};